import {initParam} from "../setting/initParam";
import {
    centeredLine, createDefaultMaterial,
    getMetaNumber,
    getOffsetsAfterRotation, InitialStruct,
    JoinPlane,
    JoinType,
    JoinVariant,
    Line2,
    matBeam, ParamsGetSimpleBoard, RenderElement,
    RenderStruct, simpleSize, Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";
import {locale} from "../setting/locale";


export async function getF7(s:InitialStruct, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {
    const lang = new URLSearchParams(window.location.search).get('lang') as 'en'|'de'|'ru' || 'en';

    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l:  sBoard.l},
        cuts: [],
        joinStart: {
            joinType: JoinType.End,
            joinPlane: JoinPlane.Bottom,
            indent: 0,
            angle: 90-s.a,
            variant: JoinVariant.Angle,
        },
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    const nameGroup = initParam.elementData.f7.groupName
    const nameElement = initParam.elementData.f7.name
    rs.group = nameGroup
    const numGroups = rs.group.length
    const meta = resultGetSimpleBoard.meta

    const realSeg = centeredLine(initParam.maps.f1.lineCut, s.l)

    const metaJEOffset1End = getMetaNumber(meta.modify, "joinEnd", "offset1")
    const metaJEOffset2End = getMetaNumber(meta.modify, "joinEnd", "offset2")
    const metaJEOffsetStart = getMetaNumber(meta.modify, "joinStart", "offset")

    const line2:Line2 = [[meta.h, 0], [meta.h, meta.l - metaJEOffset2End]]
    const line1:Line2 = [[meta.h / 2, meta.l / 2],[meta.h / 2, meta.l]]
    const line3:Line2 = [[0, 0 + metaJEOffsetStart], [0, meta.l - metaJEOffset1End]]

    const p:Line2[] = [line1, line2, line3]

    const testOfset = getOffsetsAfterRotation(p, Math.PI / 2 + initParam.angles.f4 * Math.PI / 180)

    for (let i = 0; i < realSeg.length; i++) {
        const x = realSeg[i][0]

        const z = s.h
            - initParam.gash.simple
            - initParam.gash.simple
            + initParam.elementData.f1.sizeBoard.h
            + meta.l / 2
            // - testOfset.deltaBottom

        const yR = 0
            - initParam.elementData.f2.sizeBoard.w
            // - testOfset.deltaLeft
            - initParam.maps.f6.point[0]

        const yL = 0
            + initParam.elementData.f2.sizeBoard.w / 2
            + initParam.elementData.f5.sizeBoard.w / 2
            // + testOfset.deltaLeft
            + initParam.maps.f6.point[0]

        const posR:Vec3 = [x, z, yR]
        const posL:Vec3 = [x, z, yL]

        const boardR: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posR,
            rotation: [0, 0, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
        }
        rs.elements.push(boardR)

        const boardL: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posL,
            rotation: [0, Math.PI, 0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
        }
        rs.elements.push(boardL)
    }
    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: nameElement,
        group: nameGroup,
        count: (realSeg.length) * 2,
        materialId: initParam.elementData.f7.materialId,
    })

    return {rs: rs, spec: spec}
}
